module.exports = __webpack_public_path__ + "media/images/image_dummy-db73aa63a2c2804ea7a745fd94f6023b.jpg";